import React, {useRef, useState} from "react";
import Header from "../../components/Header";
import "./style.scss";
import EnterBarCode, {EnterBarCodeHandle} from "../../components/EnterBarCode";
import FooterScanArticle from "../../components/FooterScanArticle";
import {useNavigate} from "react-router";
import menuStore from "../../stores/menu";
import {MenuItem, MenuItemCombination, ScanArticleResult} from "../../@types/stores/menu";
import {
    addToLog, getAllergenById, getCurrency,
    getCurrentCategory,
    getCurrentSubCategory, getHost, getPreferenceById, isArticleHasAllergens, isArticleHasPreferences,
    isMenuItem, isMenuItemCombination
} from "../../helpers/ApiHelper";
import {ArticleViewType} from "../../@types/enums/ArticleViewType";
import {moveToTop} from "../../helpers/DomHelper";
import {hideLoader, showLoader} from "../../helpers/ComponentHelper";
import orderStore from "../../stores/order";
import {v4 as guid} from "uuid";
import {ReactComponent as IconClose} from "../../assets/icons/x.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";
import defaultImg from "../../assets/images/default.webp";
import useLayoutStyles from "../../hooks/styles";
import {useTranslation} from "react-i18next";
import OrderIdle from "../../components/OrderIdle";


const ScanArticlePage = () => {
    const navigate = useNavigate();
    const styles = useLayoutStyles();
    const [t] = useTranslation();

    const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
    const [filteredItems, setFilteredItems] = useState<ScanArticleResult[]>([])

    const keyboardRef = useRef<EnterBarCodeHandle>(null);

    const openOrder = (): void => {
        navigate("/");
    }

    const openArticle = (item: MenuItem | MenuItemCombination, categoryId: number, subCategoryId: number) => {
        menuStore.changeCategory(categoryId);
        menuStore.changeSubCategory(subCategoryId);
        menuStore.returnToScanArticle = true;

        keyboardRef.current?.resetValue();
        closeDialog();

        if (isMenuItem(item)) {
            // ARTICLE
            item = item as MenuItem;

            const category = getCurrentCategory();
            const subCategory = getCurrentSubCategory();
            addToLog(`Click on article #${item.id} / ${item.number} / ${item.name}, category #${category?.id || "<undefined>"} / ${category?.name || "<undefined>"}, subcategory #${subCategory?.id} / ${subCategory?.name || "<undefined>"}`);

            // ONE_PAGE
            if (!localStorage.getItem("articleViewType") || localStorage.getItem("articleViewType") === ArticleViewType.ONE_PAGE) {
                navigate(`/menu/${menuStore.navigation.category}/${subCategoryId}/${item.number}`);
                return;
            }

            // GROUP_PAGE
            else if (localStorage.getItem("articleViewType") === ArticleViewType.GROUP_PAGE) {
                if (item.modifierGroups?.length) {
                    moveToTop();
                    navigate(`/menu/${menuStore.navigation.category}/${subCategoryId}/${item.number}/modifiers`);
                    return;
                } else if (item.addonGroups?.length) {
                    moveToTop();
                    navigate(`/menu/${menuStore.navigation.category}/${subCategoryId}/${item.number}/addons`);
                    return;
                } else if (item.ingredientGroups?.length) {
                    moveToTop();
                    navigate(`/menu/${menuStore.navigation.category}/${subCategoryId}/${item.number}/ingredients`);
                    return;
                } else {
                    addToOrder(item);
                    return;
                }
            }

            // INDIVIDUAL_PAGE
            else if (localStorage.getItem("articleViewType") === ArticleViewType.INDIVIDUAL_PAGE) {
                if (item.modifierGroups?.length) {
                    moveToTop();
                    navigate(`/menu/${menuStore.navigation.category}/${subCategoryId}/${item.number}/modifiers/${item.modifierGroups.at(0)?.id}`);
                    return;
                } else if (item.addonGroups?.length) {
                    moveToTop();
                    navigate(`/menu/${menuStore.navigation.category}/${subCategoryId}/${item.number}/addons/${item.addonGroups.at(0)?.id}`);
                    return;
                } else if (item.ingredientGroups?.length) {
                    moveToTop();
                    navigate(`/menu/${menuStore.navigation.category}/${subCategoryId}/${item.number}/ingredients`);
                    return;
                } else {
                    addToOrder(item);
                    return;
                }
            }
        }
        else {
            //COMBINATION
            item = item as MenuItemCombination;

            const category = getCurrentCategory();
            const subCategory = getCurrentSubCategory();
            addToLog(`Click on combination #${item.id} / ${item.name}, category #${category?.id || "<undefined>"} / ${category?.name || "<undefined>"}, subcategory #${subCategory?.id} / ${subCategory?.name || "<undefined>"}`);


            moveToTop();
            navigate(`/menu/combination/${menuStore.navigation.category}/${subCategoryId}/${item.id}`);
            return;
        }
    }

    const addToOrder = async (item: MenuItem) => {
        showLoader();
        await orderStore.addToOrder({
            id: guid(),
            menuId: menuStore.navigation.category,
            subMenuId: menuStore.navigation.subCategory,
            name: item.name,
            number: item.number,
            count: 1,
            price: item.price,
            total: item.price,
            img: item.previewList
        });

        hideLoader();
    }

    const checkArticle = (value: string): boolean => {
        const data = menuStore.findArticle(value);

        // just one -> open article
        if (data.length === 1 && !isArticleHasAllergens(data[0].item)) {
            openArticle(data[0].item, data[0].categoryId, data[0].subCategoryId);
            return true;
        }

        // several items found
        if (data.length) {
            setFilteredItems(data);
            setIsOpenDialog(true);
            return false;
        }

        return false;
    }

    const closeDialog = () => {
        setIsOpenDialog(false);
    }

    return <div className="ScanArticlePage">
        <Header />
        <div className="contentBlock">
            <EnterBarCode ref={keyboardRef} checkArticle={checkArticle}/>
            {isOpenDialog
                ? <div className="popupContent">
                    <div className="close" onClick={closeDialog}>
                        <IconClose />
                    </div>
                    <div className="itemsContentBlock">
                        <div className="items" x-filter-allergens={JSON.stringify(menuStore.filter.allergens)}>
                            {filteredItems.filter(x => isArticleHasPreferences(x.item)).map(x =>
                                <div key={`menuItem_${x.item.name}`} className="item" onClick={() => openArticle(x.item, x.categoryId, x.subCategoryId)}>
                                    <div className="tagsImages">
                                        {x.item.allergens?.filter(y => menuStore.filter.allergens.indexOf(y) !== -1).map(y => getAllergenById(y)?.image ?
                                            <img key={`allergenTagImage_${y}`}
                                                 src={`${getHost()}${getAllergenById(y)?.image || ""}`}
                                                 alt={getAllergenById(y)?.name}/> : null)}
                                        {x.item.preferences?.filter(y => menuStore.filter.preferences.indexOf(y) !== -1).map(y => getPreferenceById(y)?.image ?
                                            <img key={`preferenceTagImage_${y}`}
                                                 src={`${getHost()}${getPreferenceById(y)?.image || ""}`}
                                                 alt={getPreferenceById(y)?.name}/> : null)}
                                    </div>
                                    <div
                                        className={`img ${x.item.allergens?.filter(y => menuStore.filter.allergens.indexOf(y) !== -1).length ? "blur" : ""}`}>
                                        <LazyLoadImage alt={x.item.name}
                                                       src={x.item.previewList ? `${getHost()}${x.item.previewList}` : (styles?.article.defaultListImage ? `${getHost()}${styles.article.defaultListImage}` : defaultImg)}
                                                       effect="blur"/>
                                    </div>
                                    <div className="text">
                                        <div className="tagContainer">
                                            <div className="tags">
                                                {x.item.allergens?.filter(y => menuStore.filter.allergens.indexOf(y) !== -1).map(y => getAllergenById(y) ?
                                                    <div key={`allergenTag_${y}`}
                                                         className="tag allergen">{getAllergenById(y)?.name || ""}</div> : null)}
                                                {x.item.preferences?.filter(y => menuStore.filter.preferences.indexOf(y) !== -1).map(y => getPreferenceById(y) ?
                                                    <div key={`preferenceTag_${y}`}
                                                         className="tag preference">{getPreferenceById(y)?.name || ""}</div> : null)}
                                            </div>
                                        </div>
                                        <div className="title">
                                            {x.item.name}
                                        </div>
                                        <div className="itemFooter">
                                            <div />
                                            <div className="price">
                                                {isMenuItem(x.item)
                                                    ? `${x.item.price?.toFixed(2) || "0.00"} ${getCurrency()}`
                                                    : null
                                                }
                                                {isMenuItemCombination(x.item)
                                                    ? `${(x.item as MenuItemCombination).price ? "" : t("minPrice")} ${(x.item as MenuItemCombination).price?.toFixed(2) || (x.item as MenuItemCombination).minPrice?.toFixed(2) ||  "0.00"} ${getCurrency()}`
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                : null
            }
        </div>
        <FooterScanArticle goNext={openOrder} />
        <OrderIdle />
    </div>
}

export default ScanArticlePage;
